import { render, staticRenderFns } from "./Wenxian.vue?vue&type=template&id=59c07118&scoped=true"
import script from "./Wenxian.vue?vue&type=script&lang=js"
export * from "./Wenxian.vue?vue&type=script&lang=js"
import style0 from "./Wenxian.vue?vue&type=style&index=0&id=59c07118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c07118",
  null
  
)

export default component.exports